export default "__VITE_ASSET__aa5c2f72__"